/**
 * Homepage-only scripts (deferred). Keeps theme.js untouched.
 */
(function () {
  function setAnnouncementBarHeight() {
    var visible = document.querySelector('.shopify-section--announcement-bar:not([hidden])');
    if (visible) {
      document.documentElement.style.setProperty(
        '--announcement-bar-height',
        visible.offsetHeight.toFixed(2) + 'px'
      );
    } else {
      document.documentElement.style.setProperty('--announcement-bar-height', '0px');
    }
  }

  function initAnnouncementDismiss() {
    document.querySelectorAll('[data-announcement-dismiss="promo"]').forEach(function (btn) {
      var promo = btn.closest('.announcement-bar--promo');
      if (!promo) return;
      var section = btn.closest('.shopify-section--announcement-bar');
      var sectionId = section ? section.id.replace(/^shopify-section-/, '') : 'default';
      var key = 'announcement-promo-dismissed-' + sectionId;
      if (sessionStorage.getItem(key)) {
        promo.hidden = true;
        setAnnouncementBarHeight();
        return;
      }
      btn.addEventListener('click', function () {
        sessionStorage.setItem(key, '1');
        promo.hidden = true;
        setAnnouncementBarHeight();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAnnouncementDismiss();
      setAnnouncementBarHeight();
    });
  } else {
    initAnnouncementDismiss();
    setAnnouncementBarHeight();
  }
})();
